

















import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import VIcon from "@/components/VIcon.vue";
import BroadcastModule from "@/models/SpecialInitiatives/BroadcastModule";
import SelectedDays from "@/components/SelectedDays.vue";

@Component({
  components: {
    VIcon,
    SelectedDays,
  },
})
export default class BroadcastModuleItem extends Vue {
  @Prop({ required: true }) readonly broadcastModule!: BroadcastModule;

  get daysToString() {
    if (this.broadcastModule.timeSlots) {
      const reducer = (accumulator: string, current: string) =>
        accumulator + " " + current;
      return this.broadcastModule.timeSlots.reduce(reducer);
    }

    return "";
  }

  get totalDuration() {
    return (
      this.broadcastModule.module.spotDuration.seconds *
      this.broadcastModule.timeSlots.length *
      this.broadcastModule.days.length
    );
  }

  private get broadcastModuleTimeSlots() {
    if (this.broadcastModule.timeSlots) {
      return this.broadcastModule.timeSlots.length;
    }

    return 0;
  }
}
